import l from "react";
import { Flex as _ } from "../Flex/Flex.js";
var d = Object.defineProperty,
  o = Object.getOwnPropertySymbols,
  n = Object.prototype.hasOwnProperty,
  s = Object.prototype.propertyIsEnumerable,
  i = (r, e, a) => e in r ? d(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: a
  }) : r[e] = a,
  f = (r, e) => {
    for (var a in e || (e = {})) n.call(e, a) && i(r, a, e[a]);
    if (o) for (var a of o(e)) s.call(e, a) && i(r, a, e[a]);
    return r;
  },
  c = (r, e) => {
    var a = {};
    for (var t in r) n.call(r, t) && e.indexOf(t) < 0 && (a[t] = r[t]);
    if (r != null && o) for (var t of o(r)) e.indexOf(t) < 0 && s.call(r, t) && (a[t] = r[t]);
    return a;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const p = r => {
  var e = r,
    {
      progress: a
    } = e,
    t = c(e, ["progress"]);
  return l.createElement("div", f({
    "data-ds-component": "DS-ProgressBar",
    "aria-label": "".concat(a, "%"),
    className: "olx-progressbar",
    "data-testid": "progress-bar-content"
  }, t), l.createElement(_, {
    className: "olx-progressbar__bar",
    style: {
      "--bar-width": "".concat(a, "%")
    }
  }));
};
p.displayName = "ProgressBar";
export { p as ProgressBar };